<template>
    <v-container id="user-dialog">
        <!--//@*/*
        //    *RPD  App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->

        <v-dialog v-model="dialog" persistent scrollable max-width="1200px" :fullscreen="$vuetify.breakpoint.mobile">

            <v-card max-height="900px" class="backdrop dialog-card">

                <v-overlay absolute :value="overlay_loading">
                    <v-progress-circular indeterminate :size="80" :width="7"
                                         color="secondary"></v-progress-circular>
                </v-overlay>

                <v-card-title class="backdrop lighten-1 dialog-title">
                    <span class="text-h5">{{customTitle()}}</span>
                </v-card-title>
                <v-card-text class="backdrop pa-0 white--text">
                    <v-container>

                        <v-form v-model="valid" ref="form">
                            <!--DETAILS:-->
                            <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">

                                <div class="text-h6 mb-2"> DETAILS : </div>
                                <v-row>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field label="EMAIL*" maxlength="60" v-model="field_user.email_user" :readonly="field_user.hitnrun_usersId != 0"
                                                      placeholder="jdoe@reno.gov" :rules="[field_rules.email]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field label="PROPER NAME*" maxlength="60" v-model="field_user.proper_name"
                                                      placeholder="Jane Smith" :rules="[field_rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field label="TITLE*" maxlength="60" v-model="field_user.title"
                                                      placeholder="Detective" :rules="[field_rules.required]"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field label="PHONE*" maxlength="60" v-model="field_user.phone" v-mask="'(###) ###-####'"
                                                      placeholder="(775) 657-4759" :rules="[field_rules.phone]"></v-text-field>
                                    </v-col>
                                </v-row>

                            </div>

                            <!--UPLOAD-->
                            <div class="ma-2"></div>
                            <div class="backdrop lighten-1 pa-3 ma-0 elevation-1">

                                <div class="text-h6 mb-2"> SIGNATURE UPLOAD : </div>

                                <v-row v-if="field_user.file_sig_image.length > 0">
                                    <v-col cols="6" sm="3" md="3">
                                        <v-img max-height="200" height="200" contain eager
                                               max-width="250" width="250"
                                               :src="GenImageLink(field_user.file_sig_image)">

                                        </v-img>
                                       

                                    </v-col>
                                    
                                    <v-col cols="4" sm="4" md="4" style=" margin-top: auto;">
                                        <v-btn @click="deleteSigimage(field_user.hitnrun_usersId)" color="secondary" class="mt-auto" style=" margin-top: auto;">
                                            <v-icon color="black">$del</v-icon>
                                        </v-btn>

                                    </v-col>
                                    <v-spacer></v-spacer>
                                </v-row>
                                <v-row v-else>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-file-input v-model="field_user.file"
                                                      accept="image/png, image/jpeg, image/bmp"
                                                      placeholder="Select a signature image"
                                                      prepend-icon="$imagePlus"
                                                      label="SIGNATURE IMAGE">
                                        </v-file-input>
                                    </v-col>
                                </v-row>


                            </div>


                        </v-form>

                    </v-container>
                    <small class="mx-4">*indicates required fields</small>
                </v-card-text>

                <v-card-actions class="backdrop lighten-1 border-card">
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" class="black--text"
                           @click="closeDialog">
                        Close
                    </v-btn>
                    <v-btn color="secondary" class="black--text" :disabled="!valid"
                           @click="saveUser">
                        Save
                    </v-btn>
                </v-card-actions>

            </v-card>



        </v-dialog>

    </v-container>
</template>

<style lang="scss" scoped>
    @import "../scss/site.scss";

    .dialog-card {
        box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
    }

    .dialog-title {
        margin-bottom: 2px;
        box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
    }

    .custom-divider {
        height: 2px;
        background-color: black;
    }

    .border-card {
        margin: 2px;
    }
</style>

<script>
    /* eslint-disable */
    import { bus_common } from "../mixins/bus_common";
    export default {
        name: "user-dialog",
        mixins: [bus_common],
        props: ["user_dialog_ID"],
        data() {
            return {
                dialog: true,
                valid: false,
                overlay_loading: false,
                field_rules: {
                    required: value => !!value || 'This field is required',
                    min: v => v.length >= 8 || 'Min 8 characters',
                    max25: v => v.length <= 60 || 'Max 60 characters',
                    email: value => {
                        const pattern = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                        return pattern.test(value) || 'Please provide a valid email address'
                    },
                    min_phone: v => v.length >= 14 || 'Please enter a complete phone number',
                    phone: value => {
                        const pattern = /^\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^\d{10}$|^1\s\d{3}(-|\s)\d{3}(-|\s)\d{4}$|^(1\s?)?\(\d{3}\)(\s|\-)?\d{3}\-\d{4}$/;
                        return pattern.test(value) || 'Please provide a valid phone number'
                    },
                    filerequired: value => {
                        var bool = false;
                        if (this.field_user.file || this.field_user.file_sig_image.length > 0) {
                            bool = true;
                        }
                        else {
                            bool = false;
                        }
                        return bool || 'A signature image is required'
                    }

                },
                field_user: {
                    hitnrun_usersId: this.user_dialog_ID,
                    email_user: "",
                    proper_name: "",
                    title: "",
                    phone: "",
                    file: null,
                    file_sig_image: "",
                    s_del: "f",
                    s_user: "",
                    s_createuser: "",
                    s_createdate: "1900-01-01",
                    s_date: "1900-01-01"
                },
            };
        },
        methods: {
            customTitle() {
                if (this.field_user.hitnrun_usersId == 0)
                    return "NEW USER"
                else
                    return "EDITING A USER"
            },
            closeDialog() {
                this.dialog = false;
                setTimeout(() => {
                    this.$emit('closeDialog');
                }, 1000)

            },
            async init() {
                await this.getUserData();
            },
            async saveUser() {

                if (this.field_user.hitnrun_usersId == 0) {
                    this.saveNewUser();
                }
                else {
                    this.saveUserEdit();
                }
            },
            async saveNewUser() {

                this.overlay_loading = true;
                let formData = new FormData();
                formData.append('file', this.field_user.file);
                formData.append('hitnrun_usersId', 0);
                formData.append('email_user', this.field_user.email_user);
                formData.append('proper_name', this.field_user.proper_name);
                formData.append('title', this.field_user.title);
                formData.append('phone', this.field_user.phone);
                formData.append('s_user', this.$store.state.user.email);
                formData.append('s_del', this.field_user.s_del);

                await this.$axios.post('api/hitnrunuser/SaveNewUser', formData)
                    .then(response => {
                        this.$emit('refreshData');
                        this.overlay_loading = false;
                        let callback = () => { this.closeDialog(); }
                        this.swall_it("User Saved! ", "The user was successfully saved.", "success", callback, null);


                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                            this.overlay_loading = false;

                        }
                    });

            },
            async saveUserEdit() {

                this.overlay_loading = true;
                let formData = new FormData();
                formData.append('file_sig_image', this.field_user.file_sig_image);
                formData.append('file', this.field_user.file);
                formData.append('hitnrun_usersId', this.field_user.hitnrun_usersId);
                formData.append('email_user', this.field_user.email_user);
                formData.append('proper_name', this.field_user.proper_name);
                formData.append('title', this.field_user.title);
                formData.append('phone', this.field_user.phone);
                formData.append('s_user', this.$store.state.user.email);
                formData.append('s_del', this.field_user.s_del);

                await this.$axios.post('api/hitnrunuser/SaveUserEdit', formData)
                    .then(response => {
                        this.$emit('refreshData');
                        this.overlay_loading = false;
                        let callback = () => { this.closeDialog(); }
                        this.swall_it("User Saved! ", "The user was successfully saved.", "success", callback, null);

                    }).catch(error => {
                        if (error.response) {
                            this.swall_it("Error!", error.response.data.msg, "error", null, null);
                            this.overlay_loading = false;

                        }
                    });

            },
            async getUserData() {

                if (this.field_user.hitnrun_usersId != 0) {
                    let form = { hitnrun_usersId: this.field_user.hitnrun_usersId };
                    this.overlay_loading = true;
                    await this.$axios.post('api/hitnrunuser/getUser', form)
                        .then(response => {

                            this.field_user.email_user = response.data.email_user;
                            this.field_user.proper_name = response.data.proper_name;
                            this.field_user.title = response.data.title;
                            this.field_user.phone = response.data.phone;
                            this.field_user.file = null;
                            this.field_user.file_sig_image = response.data.file_sig_image;
                            this.field_user.s_del = response.data.s_del;
                            this.field_user.s_user = response.data.s_user;
                            this.field_user.s_createuser = response.data.s_createuser;
                            this.field_user.s_createdate = response.data.s_createdate;
                            this.field_user.s_date = response.data.s_date;
                            this.overlay_loading = false;

                        }).catch(error => {
                            if (error.response) {
                                this.swall_it("Error!", error.response.data.msg, "error", null, null);
                                this.overlay_loading = false;

                            }
                        });
                }
            },
            GenImageLink(filename) {
                let link = window.location.origin + "/Upload/" + filename;
                return link
            },
            deleteSigimage(ID) {
                let callback = () => {
                    this.field_user.file_sig_image = "";
                }
                this.swall_diag("Delete Signature Image?", "Are you sure you would like to delete the image?", "question", callback, "Yes", "No", null)
            }
        },
        mounted() {
            this.$nextTick(() => {
                this.init();
            });
        },
    };
</script>
